import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import TakingGoods from "../../../containers/modules/warehouse/taking-goods";

export default function TakingGoodsRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="taking-goods"
      index
      element={
        <AccessControl
          name={"Taking Goods List"}
          auth={authUser}
          component={() => <TakingGoods authUser={authUser} />}
        />
      }
    />
  );
}
